import { useStaticQuery, graphql } from 'gatsby';
import getServiceCategoryIds from '../utils/get-service-category-ids';
import { getUrlPath } from '../utils/get-url-path';

const PROMOTIONS_QUERY = graphql`
  query PromotionsQuery {
    allPromotions: allWpPromotion(sort: { dateGmt: DESC }) {
      nodes {
        ...Promotion
      }
    }
  }
`;

const DEFAULTS = {
  limit: 4, 
  excludePath: null
};

const usePromotions = (items = [], services = null, config) => {
  const settings = { ...DEFAULTS, ...config };
  const { allPromotions } = useStaticQuery(PROMOTIONS_QUERY);
  const serviceCatIds = services ? getServiceCategoryIds(services) : null;
  let promotions = [ ...(!items?.length ? allPromotions.nodes : items) ];

  // Normalise objects
  promotions = promotions.map(promo => {
    if(promo?.promotion && promo?.title) {
      const { promotion, ...other } = promo;
      return { ...promotion, ...other };
    } else if( promo?.promotion ) {
      const { promotion: { promotion, ...other } } = promo;
      return { ...promotion, ...other };
    } else {
      return null;
    }
  })

  // Don't show a promotion on a page it links to
  promotions = promotions.filter(promotion => {
    return promotion?.link?.url && settings.excludePath !== getUrlPath(promotion.link.url);
  });

  // If we are showing all promotions, order promotions with matching category
  if(!items?.length && serviceCatIds) {
    promotions.sort((a, b) => {
      const hasAMatch = a.servicesCategory.nodes.some((category) => {
        return serviceCatIds.some((id) => id === category.id);
      });

      const hasBMatch = b.servicesCategory.nodes.some((category) => {
        return serviceCatIds.some((id) => id === category.id);
      });

      if(hasAMatch && !hasBMatch) {
        return -1;
      }

      if(hasBMatch && !hasAMatch) {
        return 1;
      }
      
      return 0;
    })
  }

  if(promotions.length > settings.limit) {
    promotions = promotions.slice(0, settings.limit);
  }

  return promotions;
};

export default usePromotions;
